<template>
  <invoice-list-page invoice-type="corporate" />
</template>

<script>
import InvoiceListPage from '../../internal/internal-list/InvoicesList.vue'

export default {
  name: 'CorporateInvoiceList',
  components: {
    InvoiceListPage,
  },
}
</script>
